"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FullProductSvg_1 = __importDefault(require("../fullProduct/FullProductSvg"));
/*
 * Renders an SVG which is used to preview the file.
 */
function FilePreviewSvg({ file, width, height, }) {
    return (react_1.default.createElement(FullProductSvg_1.default, { design: file.design, file: file, width: width, height: height }));
}
exports.default = FilePreviewSvg;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsZVByZXZpZXdTdmcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9maWxlUHJldmlldy9GaWxlUHJldmlld1N2Zy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrREFBMEI7QUFFMUIsbUZBQTJEO0FBRTNEOztHQUVHO0FBRUgsU0FBd0IsY0FBYyxDQUFDLEVBQ3JDLElBQUksRUFDSixLQUFLLEVBQ0wsTUFBTSxHQUMwQjtJQUNoQyxPQUFPLENBQ0wsOEJBQUMsd0JBQWMsSUFDYixNQUFNLEVBQUUsSUFBSSxDQUFDLE1BQU0sRUFDbkIsSUFBSSxFQUFFLElBQUksRUFDVixLQUFLLEVBQUUsS0FBSyxFQUNaLE1BQU0sRUFBRSxNQUFNLEdBQ2QsQ0FDSCxDQUFDO0FBQ0osQ0FBQztBQWJELGlDQWFDIn0=